/**
 * @Description 文本域输入框
 */

import { FC, useEffect, useState } from 'react';
import { Form } from 'antd';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import { isNotEmpty, contrast } from '@lhb/func';
import styles from '../index.module.less';
import { estimatedDailyIdentification, explanationYHTIdentification } from '../customize';
import { ControlType, estimateSalesReasonableSelectYHT } from '../config';

export interface TextareaInputProps {
  propertyItem: any;
  disabled: boolean;
  required: boolean;
  form: any;
  tiledFormDataRef: any;
}

const TextareaInput: FC<TextareaInputProps> = ({
  propertyItem,
  disabled,
  required,
  form,
  tiledFormDataRef,
}) => {
  const label = propertyItem.anotherName || propertyItem.name || '';
  const restriction = propertyItem.restriction ? JSON.parse(propertyItem.restriction) : {};
  const placeholder = restriction.placeholder ? restriction.placeholder : `请输入${label || ''}`;
  const min = contrast(restriction, 'min');
  const max = contrast(restriction, 'max');

  const rules = [
    { required, message: placeholder },
    () => ({
      validator(_, value) {
        if (isNotEmpty(min) && isNotEmpty(value) && value.length < min) {
          return Promise.reject(`请输入至少${min}个字`);
        }
        return Promise.resolve();
      },
    }),
  ];

  // 营业额预估相关特殊处理 start
  const esrYHTValue = Form.useWatch(estimateSalesReasonableSelectYHT.keyValue, form);// 营业额预估合理值的选中值
  // 营业额预估合理值选中项改变时、控制外卖系数字段的禁用
  const [isHide, setIsHide] = useState<boolean>(false);

  useEffect(() => {
    if (propertyItem?.identification === explanationYHTIdentification) {
      // 「外卖占比填写说明」字段的特殊处理：预估结论值为系统预估的选项，隐藏本输入组件设置
      const isSystemEstimate = checkEsrSystemEstimate(esrYHTValue);
      setIsHide(isSystemEstimate);
    }
  }, [esrYHTValue]);

  /**
   * @description 检查益禾堂预估结论合理值是否为系统预估
   * @param esrValue 益禾堂预估结论合理值，为其他属性的idenfication，字符串
   * @return true 属于系统预估；false 手动输入
   */
  const checkEsrSystemEstimate = (esrValue: string) => {
    const identifications: any = [estimatedDailyIdentification];

    const limitYHTCom = tiledFormDataRef?.current?.find((item) => item.controlType === ControlType.ESTIMATE_SALES_TWO_YHT.value);
    if (limitYHTCom?.identification) {
      identifications.push(limitYHTCom.identification);
    }
    return identifications.includes(esrValue);
  };
  // 营业额预估相关特殊处理 end

  return (
    isHide ? <></> : <V2FormTextArea
      label={label}
      name={propertyItem.identification}
      placeholder={placeholder}
      maxLength={max}
      required={required}
      rules={rules}
      className={styles.textareaItem}
      disabled={disabled}
    />
  );
};

export default TextareaInput;
